import { createFileRoute, redirect } from '@tanstack/react-router';

// Legacy live-map path. The map now folds into the Dispatch cockpit
// (/dashboard/dispatch, Spec 2 map companion) — redirect old links there.
export const Route = createFileRoute('/_dashboard/dashboard/calendar/map')({
  beforeLoad: () => {
    throw redirect({
      to: '/dashboard/dispatch',
      search: {
        date: undefined,
        // Leave the colour mode unset so the route default (Job type) applies —
        // pinning `status` here stuck in the URL and hid the job-type colours.
        colorBy: undefined,
        map: 'off',
        bookingId: undefined,
        territoryId: undefined,
        jobTypeId: undefined,
        businessUnitId: undefined,
        priority: undefined,
        origin: undefined,
        exceptions: undefined,
      },
      replace: true,
    });
  },
});
